/**
 * BuildSearchParameters
 *
 * Module that takes the request object and builds query object from that
 *
 * @return {type}
 */

OT.createNS('OT.Search.Helpers.buildSearchParameters');

OT.Search.Helpers.buildSearchParameters.domainCultureKeys = [
    'Domain',
    'Culture'
];

OT.Search.Helpers.buildSearchParameters.requestKeys = [
    'AffiliateRestaurantId',
    'AreaId',
    'Attributes',
    'Covers',
    'CuisineIds',
    'CurrentView',
    'DateTime',
    'Distance',
    'ExcludeFields',
    'From',
    'IntersperseAvailability',
    'IsDateTimeCoverUpdated',
    'IsMyListsView',
    'JustAdded',
    'Latitude',
    'Longitude',
    'LoyaltyRedemption',
    'MetroId',
    'NeighborhoodIds',
    'OfferTypeIds',
    'OnlyExactDateTime',
    'OnlyPopTimes',
    'OnlyUnavailable',
    'PopularityAlgorithm',
    'PriceBandIds',
    'PromoId',
    'Rd',
    'Ref',
    'RegionIds',
    'RestRef',
    'Rids',
    'RidsAddons',
    'ShowMap',
    'Size',
    'Sort',
    'TableCategories',
    'TagIds',
    'Term',
    'Tests',
    'Title',
    'Topic',
    'WishListId'
];

OT.Search.Helpers.buildSearchParameters.addKnownKeysIfDefined = function(source, knownKeys) {
    return _.reduce(knownKeys, function(memo, key) {
      var lowerCased = key.toLowerCase();

      if (source[lowerCased]) {
        memo[lowerCased] = source[lowerCased];
      }

      return memo;
    }, {});
};

OT.Search.Helpers.buildSearchParameters.build = function (requestObj, domainCultureObj) {

	function dictionaryToLowerCaseAndTransform(dictionary, transformationHash) {
		var result = {};
		_.each(dictionary, function (val, key) {
			var keyForValue = transformationHash[key] || key;
			result[key.toLowerCase()] = dictionary[keyForValue];
		});
		return result;
	}

	function shouldAddDomainCultureToQueryString() {
		return OT.Search.Helpers.QueryString()["domain"] !== undefined ||
                OT.Search.Helpers.QueryString()["culture"] !== undefined;
	}

	var transformationHash = {
		'Sort': 'SortString'
	};

	requestObj = dictionaryToLowerCaseAndTransform(requestObj, transformationHash) || {};
	domainCultureObj = dictionaryToLowerCaseAndTransform(domainCultureObj, transformationHash) || {};

	var params = OT.Search.Helpers.buildSearchParameters.addKnownKeysIfDefined(
        requestObj,
        OT.Search.Helpers.buildSearchParameters.requestKeys
    );

    if (shouldAddDomainCultureToQueryString()) {
        // Intentional mutation of 'params'
        _.extend(params, OT.Search.Helpers.buildSearchParameters.addKnownKeysIfDefined(
            domainCultureObj,
            OT.Search.Helpers.buildSearchParameters.domainCultureKeys
        ));
    }

    return params;
};
